import { defineMessages } from "react-intl";
export default defineMessages({
  premiumAccount: {
    "id": "common.premiumAccount",
    "defaultMessage": "Premium account"
  },
  freeAccount: {
    "id": "common.freeAccount",
    "defaultMessage": "Free account"
  },
  manage: {
    "id": "common.manage",
    "defaultMessage": "Manage"
  },
  switchToPremium: {
    "id": "common.switchToPremium",
    "defaultMessage": "Switch to SmartMixin Premium"
  },
  alreadyPremium: {
    "id": "common.alreadyPremium",
    "defaultMessage": "You already have a premium account!"
  },
  freeSubscription: {
    "id": "common.freeSubscription",
    "defaultMessage": "Free premium subscription"
  },
  purchasedNetatmoPro: {
    "id": "common.purchasedNetatmoPro",
    "defaultMessage": "You previously purchased Netatmo Pro ({date}). It gives you access to a subset of premium features. Subscribe to one of the following offers if you want to have access to all premium features."
  },
  premiumDescription: {
    "id": "common.premiumDescription",
    "defaultMessage": "Premium subscription unlocks many additional features such as advanced weather analysis, chart comparisons, regional forecast models and lots more."
  },
  freeTrialForPeriod: {
    "id": "common.freeTrialForPeriod",
    "defaultMessage": "Free trial for {period} days"
  },
  manageMySubscription: {
    "id": "common.manageMySubscription",
    "defaultMessage": "Manage my subscription"
  },
  restorePurchase: {
    "id": "common.restorePurchase",
    "defaultMessage": "Restore purchase"
  },
  notPurchasedYet: {
    "id": "common.notPurchasedYet",
    "defaultMessage": "It seems this has not been purchased yet."
  },
  billingDetails: {
    "id": "common.billingDetails",
    "defaultMessage": "For free trial offer, you will not be charged if you cancel 24 hours before the free introductory period expires. When the trial is over, you can cancel SmartMixin subscription anytime through your App Store account settings, or it will be automatically renewed. This must be done 24 hours before the end of the subscription period to avoid being charged another fee shown in the button above. Subscription payments will be charged to your App Store account at confirmation of your purchase and upon commencement of each renewal term."
  },
  loading: {
    "id": "common.loading",
    "defaultMessage": "Loading"
  },
  resetZoom: {
    "id": "common.resetZoom",
    "defaultMessage": "Reset Zoom"
  },
  range: {
    "id": "common.range",
    "defaultMessage": "Range"
  },
  averageOverThePeriod: {
    "id": "common.averageOverThePeriod",
    "defaultMessage": "Average over the period"
  },
  sumOverThePeriod: {
    "id": "common.sumOverThePeriod",
    "defaultMessage": "Cumulated over the period"
  },
  average: {
    "id": "common.average",
    "defaultMessage": "Average"
  },
  weatherStation: {
    "id": "common.weatherStation",
    "defaultMessage": "Weather station"
  },
  weatherStations: {
    "id": "common.weatherStations",
    "defaultMessage": "Weather stations"
  },
  selectWeatherForecastProvider: {
    "id": "common.selectWeatherForecastProvider",
    "defaultMessage": "Please choose a weather provider"
  },
  editor: {
    "id": "common.editor",
    "defaultMessage": "Editor"
  },
  meshSize: {
    "id": "common.meshSize",
    "defaultMessage": "Grid size"
  },
  horizon: {
    "id": "common.horizon",
    "defaultMessage": "Horizon"
  },
  horizonValue: {
    "id": "common.horizonValue",
    "defaultMessage": "up to {value} hours"
  },
  frequency: {
    "id": "common.frequency",
    "defaultMessage": "Frequency"
  },
  moreInformation: {
    "id": "common.moreInformation",
    "defaultMessage": "More information"
  },
  timeSelection: {
    "id": "common.timeSelection",
    "defaultMessage": "Time selection"
  },
  comparison: {
    "id": "common.comparison",
    "defaultMessage": "Comparison"
  },
  cannotBeEmpty: {
    "id": "common.cannotBeEmpty",
    "defaultMessage": "This field cannot be empty."
  },
  validEmail: {
    "id": "common.validEmail",
    "defaultMessage": "A valid email address is required."
  },
  passwordUpdated: {
    "id": "common.passwordUpdated",
    "defaultMessage": "Password successfully updated."
  },
  profileUpdated: {
    "id": "common.profileUpdated",
    "defaultMessage": "Profile successfully updated."
  },
  accountDeleted: {
    "id": "common.accountDeleted",
    "defaultMessage": "Your account has been successfully deleted."
  },
  deleteAccount: {
    "id": "common.deleteAccount",
    "defaultMessage": "Delete your account"
  },
  deleteAccountConfirmation: {
    "id": "common.deleteAccountConfirmation",
    "defaultMessage": "Are you sure you want to delete your account? This action is irreversible."
  },
  deleteAccountDescription: {
    "id": "common.deleteAccountDescription",
    "defaultMessage": "This action deletes your account and all your information. There is no going back."
  },
  yes: {
    "id": "common.yes",
    "defaultMessage": "Yes"
  },
  no: {
    "id": "common.no",
    "defaultMessage": "No"
  },
  close: {
    "id": "common.close",
    "defaultMessage": "Close"
  },
  chartView: {
    "id": "common.chartView",
    "defaultMessage": "Chart view"
  },
  calendarView: {
    "id": "common.calendarView",
    "defaultMessage": "Calendar view"
  },
  // Netatmo
  outdatedModule: {
    "id": "common.outdatedModule",
    "defaultMessage": "The data for this module is out of date.",
    "description": "Netatmo"
  },
  noOutdoorModule: {
    "id": "common.noOutdoorModule",
    "defaultMessage": "There is no functional outdoor module for this station."
  },
  outdoor: {
    "id": "common.outdoor",
    "defaultMessage": "Outdoor"
  },
  indoor: {
    "id": "common.indoor",
    "defaultMessage": "Indoor"
  },
  rain: {
    "id": "common.rain",
    "defaultMessage": "Rain"
  },
  wind: {
    "id": "common.wind",
    "defaultMessage": "Wind"
  },
  stationName: {
    "id": "common.stationName",
    "defaultMessage": "Station name"
  },
  location: {
    "id": "common.location",
    "defaultMessage": "Location"
  },
  timezone: {
    "id": "common.timezone",
    "defaultMessage": "Timezone"
  },
  altitude: {
    "id": "common.altitude",
    "defaultMessage": "Altitude"
  },
  serialNumber: {
    "id": "common.serialNumber",
    "defaultMessage": "Serial number"
  },
  firmwareVersion: {
    "id": "common.firmwareVersion",
    "defaultMessage": "Firmware version"
  },
  signalStrength: {
    "id": "common.signalStrength",
    "defaultMessage": "Signal strength"
  },
  batteryLevel: {
    "id": "common.batteryLevel",
    "defaultMessage": "Battery level"
  },
  bad: {
    "id": "common.bad",
    "defaultMessage": "Bad"
  },
  good: {
    "id": "common.good",
    "defaultMessage": "Good"
  },
  lastUpdate: {
    "id": "common.lastUpdate",
    "defaultMessage": "Last update"
  },
  stationInformation: {
    "id": "common.stationInformation",
    "defaultMessage": "Station information"
  },
  dashboard: {
    "id": "common.dashboard",
    "defaultMessage": "Dashboard"
  },
  forecast: {
    "id": "common.forecast",
    "defaultMessage": "Forecast"
  },
  forecastSources: {
    "id": "common.forecastSources",
    "defaultMessage": "Forecast sources"
  },
  charts: {
    "id": "common.charts",
    "defaultMessage": "Charts"
  },
  analysis: {
    "id": "common.analysis",
    "defaultMessage": "Analysis"
  },
  more: {
    "id": "common.more",
    "defaultMessage": "More"
  },
  homeInformation: {
    "id": "common.homeInformation",
    "defaultMessage": "Home information"
  },
  homeName: {
    "id": "common.homeName",
    "defaultMessage": "Home name"
  },
  relay: {
    "id": "common.relay",
    "defaultMessage": "Relay"
  },
  smartThermostat: {
    "id": "common.smartThermostat",
    "defaultMessage": "Smart thermostat"
  },
  smartValve: {
    "id": "common.smartValve",
    "defaultMessage": "Smart valve"
  },
  moduleType: {
    "id": "common.moduleType",
    "defaultMessage": "Module type"
  },
  very_low: {
    "id": "common.very_low",
    "defaultMessage": "Very low"
  },
  low: {
    "id": "common.low",
    "defaultMessage": "Low"
  },
  medium: {
    "id": "common.medium",
    "defaultMessage": "Medium"
  },
  high: {
    "id": "common.high",
    "defaultMessage": "High"
  },
  full: {
    "id": "common.full",
    "defaultMessage": "Full"
  },
  wifiStrength: {
    "id": "common.wifiStrength",
    "defaultMessage": "WiFi strength"
  },
  rooms: {
    "id": "common.rooms",
    "defaultMessage": "Rooms"
  },
  room: {
    "id": "common.room",
    "defaultMessage": "Room"
  },
  untilTime: {
    "id": "common.untilTime",
    "defaultMessage": "Until {time}"
  },
  hg: {
    "id": "common.hg",
    "defaultMessage": "Frost guard"
  },
  away: {
    "id": "common.away",
    "defaultMessage": "Away"
  },
  edit: {
    "id": "common.edit",
    "defaultMessage": "Edit"
  },
  add: {
    "id": "common.add",
    "defaultMessage": "Add"
  },
  "delete": {
    "id": "common.delete",
    "defaultMessage": "Delete"
  },
  cancel: {
    "id": "common.cancel",
    "defaultMessage": "Cancel"
  },
  validate: {
    "id": "common.validate",
    "defaultMessage": "Validate"
  },
  untilChanged: {
    "id": "common.untilChanged",
    "defaultMessage": "Until changed"
  },
  manualSetpointUntil: {
    "id": "common.manualSetpointUntil",
    "defaultMessage": "Manual setpoint until"
  },
  manualBoost: {
    "id": "common.manualBoost",
    "defaultMessage": "Manual boost"
  },
  whenBackHome: {
    "id": "common.whenBackHome",
    "defaultMessage": "When will you be back home?"
  },
  iDontKnowYet: {
    "id": "common.iDontKnowYet",
    "defaultMessage": "I don't know yet"
  },
  boilerOn: {
    "id": "common.boilerOn",
    "defaultMessage": "Boiler ON"
  },
  noDataForThisPeriod: {
    "id": "common.noDataForThisPeriod",
    "defaultMessage": "No data for this period"
  },
  upgradeRequired: {
    "id": "common.upgradeRequired",
    "defaultMessage": "An upgrade of your application is required. Visit the App Store to upgrade."
  },
  upgrade: {
    "id": "common.upgrade",
    "defaultMessage": "Upgrade"
  },
  noNetatmoWeatherStationYet: {
    "id": "common.noNetatmoWeatherStationYet",
    "defaultMessage": "You don't have a Netatmo weather station yet."
  },
  visitNetatmoWebsite: {
    "id": "common.visitNetatmoWebsite",
    "defaultMessage": "Visit Netatmo website"
  },
  accountOnHold: {
    "id": "common.accountOnHold",
    "defaultMessage": "Your account has been placed on hold. Click the link for further instructions."
  },
  manageAccount: {
    "id": "common.manageAccount",
    "defaultMessage": "Manage account"
  },
  noThermostatYet: {
    "id": "common.noThermostatYet",
    "defaultMessage": "You dont' have a thermostat yet."
  },
  home: {
    "id": "common.home",
    "defaultMessage": "Home"
  },
  welcome: {
    "id": "common.welcome",
    "defaultMessage": "Welcome to SmartMixin!"
  },
  homeIntroduction: {
    "id": "common.homeIntroduction",
    "defaultMessage": "Start connecting your external accounts to enjoy SmartMixin features."
  },
  weatherMap: {
    "id": "common.weatherMap",
    "defaultMessage": "Weathermap"
  },
  filterStations: {
    "id": "common.filterStations",
    "defaultMessage": "Filter stations"
  },
  filterStationDescription: {
    "id": "common.filterStationDescription",
    "defaultMessage": "Do not display stations with unreliable measures"
  },
  filterStationSourceDescription: {
    "id": "common.filterStationSourceDescription",
    "defaultMessage": "Select station providers that you want to display on the map"
  },
  rainfallMeasurement: {
    "id": "common.rainfallMeasurement",
    "defaultMessage": "Rainfall measurement"
  },
  windMeasurement: {
    "id": "common.windMeasurement",
    "defaultMessage": "Wind measurement"
  },
  outdoorTemperature: {
    "id": "common.outdoorTemperature",
    "defaultMessage": "Outdoor temperature"
  },
  share: {
    "id": "common.share",
    "defaultMessage": "Share"
  },
  shareYourWeather: {
    "id": "common.shareYourWeather",
    "defaultMessage": "Share your weather"
  },
  noWeatherStationYet: {
    "id": "common.noWeatherStationYet",
    "defaultMessage": "You don't have a weather station yet."
  },
  removeFromFavorites: {
    "id": "common.removeFromFavorites",
    "defaultMessage": "Remove from favorites"
  },
  addToFavorites: {
    "id": "common.addToFavorites",
    "defaultMessage": "Add to favorites"
  },
  currentObservations: {
    "id": "common.currentObservations",
    "defaultMessage": "Current observations"
  },
  nextHours: {
    "id": "common.nextHours",
    "defaultMessage": "Next hours"
  },
  dailyForecast: {
    "id": "common.dailyForecast",
    "defaultMessage": "Daily forecast"
  },
  rainRadar: {
    "id": "common.rainRadar",
    "defaultMessage": "Rain radar"
  },
  rainRadarDescription: {
    "id": "common.rainRadarDescription",
    "defaultMessage": "Display rain radar overlay on the map"
  },
  clouds: {
    "id": "common.clouds",
    "defaultMessage": "Clouds"
  },
  satelliteCloudsDescription: {
    "id": "common.satelliteCloudsDescription",
    "defaultMessage": "Display clouds overlay on the map"
  },
  details: {
    "id": "common.details",
    "defaultMessage": "Details"
  },
  favoriteStations: {
    "id": "common.favoriteStations",
    "defaultMessage": "Favorite stations"
  },
  recentStations: {
    "id": "common.recentStations",
    "defaultMessage": "Recent stations"
  },
  noWeatherStation: {
    "id": "common.noWeatherStation",
    "defaultMessage": "No weather station"
  },
  locations: {
    "id": "common.locations",
    "defaultMessage": "Locations"
  },
  recentLocationsEmpty: {
    "id": "common.recentLocationsEmpty",
    "defaultMessage": "You recent history is empty."
  },
  favoriteLocationsEmpty: {
    "id": "common.favoriteLocationsEmpty",
    "defaultMessage": "You can add up to 5 favorite locations."
  },
  maxFavoriteLocationsReached: {
    "id": "common.maxFavoriteLocationsReached",
    "defaultMessage": "You can only have up to 5 favorite locations. Remove one to add another."
  },
  recentLocations: {
    "id": "common.recentLocations",
    "defaultMessage": "Recent"
  },
  favoriteLocations: {
    "id": "common.favoriteLocations",
    "defaultMessage": "Favorites"
  },
  locationRemovedFromFavorites: {
    "id": "common.locationRemovedFromFavorites",
    "defaultMessage": "Location removed from favorites"
  },
  locationAddedToFavorites: {
    "id": "common.locationAddedToFavorites",
    "defaultMessage": "Location added to favorites"
  },
  searchForLocation: {
    "id": "common.searchForLocation",
    "defaultMessage": "Search for a location"
  },
  aroundMe: {
    "id": "common.aroundMe",
    "defaultMessage": "Around me"
  },
  stationRemovedFromFavorites: {
    "id": "common.stationRemovedFromFavorites",
    "defaultMessage": "Station removed from favorites"
  },
  stationAddedToFavorites: {
    "id": "common.stationAddedToFavorites",
    "defaultMessage": "Station added to favorites"
  },
  searchForWeatherStation: {
    "id": "common.searchForWeatherStation",
    "defaultMessage": "Search for a weather station"
  },
  clearRecentLocations: {
    "id": "common.clearRecentLocations",
    "defaultMessage": "Clear all"
  },
  currentLocation: {
    "id": "common.currentLocation",
    "defaultMessage": "Current location"
  },
  currentWeatherConditions: {
    "id": "common.currentWeatherConditions",
    "defaultMessage": "Current conditions"
  },
  shareOutdoorMeasures: {
    "id": "common.shareOutdoorMeasures",
    "defaultMessage": "Share your outdoor measures"
  },
  shareOutdoorMeasuresDescription: {
    "id": "common.shareOutdoorMeasuresDescription",
    "defaultMessage": "Participate in the SmartMixin community by making your outdoor measures visible to others. Indoor measures will never be shared."
  },
  customizedStationName: {
    "id": "common.customizedStationName",
    "defaultMessage": "Customized station name"
  },
  stationType: {
    "id": "common.stationType",
    "defaultMessage": "Station type"
  },
  addYourOwnStation: {
    "id": "common.addYourOwnStation",
    "defaultMessage": "Add your own station"
  },
  weatherForecastModels: {
    "id": "common.weatherForecastModels",
    "defaultMessage": "Weather forecast models"
  },
  forecastModelComparison: {
    "id": "common.forecastModelComparison",
    "defaultMessage": "Forecast model comparison"
  },
  forecastComparisonDescription: {
    "id": "common.forecastComparisonDescription",
    "defaultMessage": "Easily compare forecast model outputs from several sources"
  },
  addAStation: {
    "id": "common.addAStation",
    "defaultMessage": "Add a station"
  },
  measureToDisplay: {
    "id": "common.measureToDisplay",
    "defaultMessage": "Measure to display"
  },
  renameSensors: {
    "id": "common.renameSensors",
    "defaultMessage": "Rename sensors"
  },
  selectStationForComparison: {
    "id": "common.selectStationForComparison",
    "defaultMessage": "Select a station to compare with"
  },
  stationComparison: {
    "id": "common.stationComparison",
    "defaultMessage": "Station comparison"
  },
  stationComparisonDescription: {
    "id": "common.stationComparisonDescription",
    "defaultMessage": "Compare historical weather data with another station"
  },
  temperatureSummary: {
    "id": "common.temperatureSummary",
    "defaultMessage": "Temperature summary"
  },
  rainSummary: {
    "id": "common.rainSummary",
    "defaultMessage": "Rain summary"
  },
  windSummary: {
    "id": "common.windSummary",
    "defaultMessage": "Wind summary"
  },
  pressureSummary: {
    "id": "common.pressureSummary",
    "defaultMessage": "Pressure summary"
  },
  currentDay: {
    "id": "common.currentDay",
    "defaultMessage": "Current day"
  },
  monthTotal: {
    "id": "common.monthTotal",
    "defaultMessage": "Month total"
  },
  yearToDate: {
    "id": "common.yearToDate",
    "defaultMessage": "Year to Date"
  },
  rainEvents: {
    "id": "common.rainEvents",
    "defaultMessage": "Rain events"
  },
  currentRate: {
    "id": "common.currentRate",
    "defaultMessage": "Current rate"
  },
  currentRainEvent: {
    "id": "common.currentRainEvent",
    "defaultMessage": "Current rain event"
  },
  lastRainEvent: {
    "id": "common.lastRainEvent",
    "defaultMessage": "Last rain event"
  },
  startTime: {
    "id": "common.startTime",
    "defaultMessage": "Start time"
  },
  endTime: {
    "id": "common.endTime",
    "defaultMessage": "End time"
  },
  totalDuration: {
    "id": "common.totalDuration",
    "defaultMessage": "Total duration"
  },
  weatherflowNCRain: {
    "id": "common.weatherflowNCRain",
    "defaultMessage": "NC Rain (Nearcast Rain)"
  },
  weatherflowNCRainDescription: {
    "id": "common.weatherflowNCRainDescription",
    "defaultMessage": "NC Rain is an additional data source provided via the Tempest Weather System, powered by Nearcast Technology. NC Rain data is an estimate of the average rainfall accumulation around your Tempest at the neighborhood level"
  },
  cardDetails: {
    "id": "common.cardDetails",
    "defaultMessage": "Card details"
  },
  weatherObservations: {
    "id": "common.weatherObservations",
    "defaultMessage": "Weather observations"
  },
  stationObservationsDescription: {
    "id": "common.stationObservationsDescription",
    "defaultMessage": "Display the latest observations from weather stations"
  },
  locationNotGranted: {
    "id": "common.locationNotGranted",
    "defaultMessage": "Location permission is not granted. Please allow access to your location in device settings."
  },
  openSettings: {
    "id": "common.openSettings",
    "defaultMessage": "Open Settings"
  },
  next: {
    "id": "common.next",
    "defaultMessage": "Next"
  },
  previous: {
    "id": "common.previous",
    "defaultMessage": "Previous"
  },
  start: {
    "id": "common.start",
    "defaultMessage": "Start"
  },
  skip: {
    "id": "common.skip",
    "defaultMessage": "Skip"
  },
  unknown: {
    "id": "common.unknown",
    "defaultMessage": "Unknown"
  },
  numberOfActiveWarnings: {
    "id": "common.numberOfActiveWarnings",
    "defaultMessage": "{warning_count} active weather warnings"
  },
  searchResults: {
    "id": "common.searchResults",
    "defaultMessage": "Search results"
  },
  searchResultsEmpty: {
    "id": "common.searchResultsEmpty",
    "defaultMessage": "No results found."
  },
  modifyFavoriteStations: {
    "id": "common.modifyFavoriteStations",
    "defaultMessage": "Modify favorite stations"
  },
  modifyFavoriteStationsDescription: {
    "id": "common.modifyFavoriteStationsDescription",
    "defaultMessage": "You can reorder your favorite stations by dragging them. You can also remove them from the list."
  },
  hiddenStations: {
    "id": "common.hiddenStations",
    "defaultMessage": "Hidden stations"
  },
  hiddenStationsDescription: {
    "id": "common.hiddenStationsDescription",
    "defaultMessage": "You can unhide a station by tapping the eye icon next to it."
  },
  nearbyWeatherStations: {
    "id": "common.nearbyWeatherStations",
    "defaultMessage": "Nearby weather stations"
  },
  help: {
    "id": "common.help",
    "defaultMessage": "Help"
  },
  helpCenter: {
    "id": "common.helpCenter",
    "defaultMessage": "Help Center"
  },
  // Help Center categories
  helpCategoryGettingStarted: {
    "id": "common.helpCategoryGettingStarted",
    "defaultMessage": "Getting Started",
    "description": "Help Center categories"
  },
  helpCategoryAccount: {
    "id": "common.helpCategoryAccount",
    "defaultMessage": "Account"
  },
  helpCategoryStations: {
    "id": "common.helpCategoryStations",
    "defaultMessage": "Stations"
  },
  helpCategoryProviders: {
    "id": "common.helpCategoryProviders",
    "defaultMessage": "Providers"
  },
  helpCategoryBilling: {
    "id": "common.helpCategoryBilling",
    "defaultMessage": "Billing"
  },
  helpCategoryTroubleshooting: {
    "id": "common.helpCategoryTroubleshooting",
    "defaultMessage": "Troubleshooting"
  },
  // Help Center UI
  searchArticles: {
    "id": "common.searchArticles",
    "defaultMessage": "Search articles...",
    "description": "Help Center UI"
  },
  relatedArticles: {
    "id": "common.relatedArticles",
    "defaultMessage": "Related Articles"
  },
  backToHelpCenter: {
    "id": "common.backToHelpCenter",
    "defaultMessage": "Back to Help Center"
  },
  articleNotFound: {
    "id": "common.articleNotFound",
    "defaultMessage": "Article Not Found"
  },
  articleNotFoundDescription: {
    "id": "common.articleNotFoundDescription",
    "defaultMessage": "The article you're looking for doesn't exist."
  },
  categoryNotFound: {
    "id": "common.categoryNotFound",
    "defaultMessage": "Category not found"
  },
  categoryNotFoundDescription: {
    "id": "common.categoryNotFoundDescription",
    "defaultMessage": "This category doesn't exist or has no articles."
  },
  minRead: {
    "id": "common.minRead",
    "defaultMessage": "{minutes} min read"
  },
  articleCount: {
    "id": "common.articleCount",
    "defaultMessage": "{count, plural, one {# article} other {# articles}}"
  },
  wasArticleHelpful: {
    "id": "common.wasArticleHelpful",
    "defaultMessage": "Was this article helpful?"
  },
  thankYouForFeedback: {
    "id": "common.thankYouForFeedback",
    "defaultMessage": "Thank you for your feedback!"
  },
  feedbackHelpsImprove: {
    "id": "common.feedbackHelpsImprove",
    "defaultMessage": "Your input helps us improve our help articles."
  },
  helpCenterDescription: {
    "id": "common.helpCenterDescription",
    "defaultMessage": "Find answers to common questions and learn how to get the most out of SmartMixin."
  },
  browseByCategory: {
    "id": "common.browseByCategory",
    "defaultMessage": "Browse by Category"
  },
  // Landing page
  personalWeatherIntelligence: {
    "id": "common.personalWeatherIntelligence",
    "defaultMessage": "Your Personal Weather Intelligence",
    "description": "Landing page"
  },
  weatherIntelligencePlatform: {
    "id": "common.weatherIntelligencePlatform",
    "defaultMessage": "The Weather Intelligence Platform"
  },
  getStartedFree: {
    "id": "common.getStartedFree",
    "defaultMessage": "Get Started Free"
  },
  exploreWeatherMap: {
    "id": "common.exploreWeatherMap",
    "defaultMessage": "Explore Weather Map"
  },
  alsoAvailableOn: {
    "id": "common.alsoAvailableOn",
    "defaultMessage": "Also available on:"
  },
  // 404 page
  pageNotFound: {
    "id": "common.pageNotFound",
    "defaultMessage": "Page Not Found",
    "description": "404 page"
  },
  pageNotFoundDescription: {
    "id": "common.pageNotFoundDescription",
    "defaultMessage": "The page you're looking for doesn't exist or has been moved."
  },
  backToHome: {
    "id": "common.backToHome",
    "defaultMessage": "Back to Home"
  },
  // Search
  noLocationsFound: {
    "id": "common.noLocationsFound",
    "defaultMessage": "No locations found",
    "description": "Search"
  },
  // Map
  myLocation: {
    "id": "common.myLocation",
    "defaultMessage": "My location",
    "description": "Map"
  },
  // Station status
  statusOnline: {
    "id": "common.statusOnline",
    "defaultMessage": "Online",
    "description": "Station status"
  },
  statusStale: {
    "id": "common.statusStale",
    "defaultMessage": "Stale"
  },
  statusOffline: {
    "id": "common.statusOffline",
    "defaultMessage": "Offline"
  },
  statusSyncing: {
    "id": "common.statusSyncing",
    "defaultMessage": "Syncing"
  },
  // Station search
  searchStationsDescription: {
    "id": "common.searchStationsDescription",
    "defaultMessage": "Enter a city, address, or place name to find weather stations nearby.",
    "description": "Station search"
  },
  searchForALocation: {
    "id": "common.searchForALocation",
    "defaultMessage": "Search for a location..."
  },
  findStationsNearYou: {
    "id": "common.findStationsNearYou",
    "defaultMessage": "Find Stations Near You"
  },
  searchStationsHint: {
    "id": "common.searchStationsHint",
    "defaultMessage": "Use the search bar above to discover weather stations in any location around the world."
  },
  noStationsFound: {
    "id": "common.noStationsFound",
    "defaultMessage": "No Stations Found"
  },
  tryAnotherLocation: {
    "id": "common.tryAnotherLocation",
    "defaultMessage": "We couldn't find any weather stations near this location. Try searching for a different area."
  },
  stationsNear: {
    "id": "common.stationsNear",
    "defaultMessage": "Stations near"
  },
  station: {
    "id": "common.station",
    "defaultMessage": "station"
  },
  stations: {
    "id": "common.stations",
    "defaultMessage": "stations"
  },
  // Premium UX
  premiumFeatureTitle: {
    "id": "common.premiumFeatureTitle",
    "defaultMessage": "Premium Feature",
    "description": "Premium UX"
  },
  premiumFeatureAlerts: {
    "id": "common.premiumFeatureAlerts",
    "defaultMessage": "Weather Alerts"
  },
  premiumFeatureCharts: {
    "id": "common.premiumFeatureCharts",
    "defaultMessage": "Chart Comparisons"
  },
  premiumFeatureForecast: {
    "id": "common.premiumFeatureForecast",
    "defaultMessage": "Regional Forecast Models"
  },
  premiumFeatureAnalysis: {
    "id": "common.premiumFeatureAnalysis",
    "defaultMessage": "Advanced Weather Analysis"
  },
  premiumFeatureExport: {
    "id": "common.premiumFeatureExport",
    "defaultMessage": "Data Export"
  },
  premiumFeatureNotification: {
    "id": "common.premiumFeatureNotification",
    "defaultMessage": "Status Bar Widget"
  },
  premiumFeatureWidgets: {
    "id": "common.premiumFeatureWidgets",
    "defaultMessage": "Home Screen Widgets"
  },
  getUnlimitedAccess: {
    "id": "common.getUnlimitedAccess",
    "defaultMessage": "Get unlimited access to:"
  },
  bestValue: {
    "id": "common.bestValue",
    "defaultMessage": "Best Value"
  },
  savingsPercent: {
    "id": "common.savingsPercent",
    "defaultMessage": "Save {percent}%"
  },
  startFreeTrial: {
    "id": "common.startFreeTrial",
    "defaultMessage": "Start Free Trial"
  },
  thenPrice: {
    "id": "common.thenPrice",
    "defaultMessage": "then {price}"
  },
  notNow: {
    "id": "common.notNow",
    "defaultMessage": "Not Now"
  },
  subscribeNow: {
    "id": "common.subscribeNow",
    "defaultMessage": "Subscribe now - no trial"
  },
  orChooseMonthly: {
    "id": "common.orChooseMonthly",
    "defaultMessage": "Or choose monthly:"
  }
});